import { Component } from '@angular/core';
// import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  ApiUsersPutRequestParams,
  UsersService,
} from '../../../backend/api/users.service';
import { UserRoleEnum } from '../../../backend/model/userRoleEnum';
import { BaseComponent } from '../../../core/components/base/base.component';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig } from '../../../core/dialog/dialog.service';
import { AuthService } from '../../../core/services/auth.service';
import { UsersComponent } from 'src/app/pages/users/users.component';

@Component({
  templateUrl: './save-user-dialog.component.html'
})

export class SaveUserDialogComponent extends BaseComponent {
  UserRole = UserRoleEnum;
  form = new UntypedFormGroup({});
  id: number = 0;
  isLoading = false;
  isSaving = false;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private t: TranslateService,
    private usersService: UsersService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
    const config = this.dialogConfig;
    this.id = config.data?.id;

    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      role: new UntypedFormControl(this.UserRole.User),
      password: new UntypedFormControl(
        '',
        !this.id ? [Validators.required, Validators.min(6)] : []
      ),
    });

    if (this.id) {
      this.loadUser(this.id);
    }
  }

  loadUser(id: number) {
    this.isLoading = true;

    this.usersService.apiUsersIdGet({ id }).subscribe(
      (res) => {
        this.isLoading = false;
        this.form.patchValue({
          name: res.name,
          email: res.email,
          role: res.role,
        });
      },
      () => {
        this.isLoading = false;
        this.close();
      }
    );
  }

  close(saved?: boolean) {
    this.dialogRef.close({ saved });
  }

  save() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
      return;
    }

    const data: ApiUsersPutRequestParams = {
      name: this.form.value.name,
      email: this.form.value.email,
      role: this.form.value.role,
      password: this.form.value.password || null,
    };

    const apiCall = this.id
      ? this.usersService.apiUsersPut({
          id: this.id,
          ...data,
        })
      : this.usersService.apiUsersPost(data);

    this.isSaving = true;

    apiCall.subscribe(
      (res) => {
        this.isSaving = false;
        this.close(true);
      },
      (err) => {
        this.isSaving = false;
        this.errorHandler(err, this.form);
      }
    );
  }
}
